import React from 'react';

import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import './footer.css';

const quickLinks = [
	{
		id: 1,
		path: '/about',
		display: 'About',
	},

	{
		id: 2,
		path: '#',
		display: 'Privacy Policy',
	},

	{
		id: 3,
		path: '/cars',
		display: 'Car Listing',
	},
	{
		id: 4,
		path: '/blogs',
		display: 'Blog',
	},

	{
		id: 5,
		path: '/contact',
		display: 'Contact',
	},
];
const officeInfo = [
	{
		id: 1,
		display: 'Oran City, Algeria',
	},

	{
		id: 2,
		display: 'Phone: +0995345875365',
	},

	{
		id: 3,
		display: 'Email: redaghost6@gmail.com',
	},
	{
		id: 4,
		display: 'Office Time: 10am - 7pm',
	},
];

const Footer = () => {
	return (
		<footer className='footer'>
			<Container>
				<Row>
					<Col lg='4' md='4' sm='12'>
						<div className='logo footer__logo'>
							<h1>
								<Link to='/home' className=' d-flex align-items-center gap-2'>
									<i class='ri-car-line'></i>
									<span>
										Drive Cars <br /> Service
									</span>
								</Link>
							</h1>
						</div>
						<p className='footer__logo-content'>
							Lorem ipsum dolor sit amet consectetur adipisicing elit.
							Consequuntur, distinctio, itaque reiciendis ab cupiditate harum ex
							quam veniam, omnis expedita animi quibusdam obcaecati mollitia?
							Delectus et ad illo recusandae temporibus?
						</p>
					</Col>

					<Col lg='2' md='4' sm='6'>
						<div className='mb-4'>
							<h5 className='footer__link-title'>Quick Links</h5>
							<ListGroup>
								{quickLinks.map(({ path, display, id }) => (
									<ListGroupItem key={id} className='p-0 mt-3 quick__link'>
										<Link to={path}>{display}</Link>
									</ListGroupItem>
								))}
							</ListGroup>
						</div>
					</Col>

					<Col lg='3' md='4' sm='6'>
						<div className='mb-4'>
							<h5 className='footer__link-title mb-4'>Head Office</h5>
							{officeInfo.map(({ display, id }) => {
								return (
									<p className='office__info' key={id}>
										{display}
									</p>
								);
							})}
						</div>
					</Col>

					<Col lg='3' md='4' sm='12'>
						<div className='mb-4'>
							<h5 className='footer__link-title'>Newsletter</h5>
							<p className='section__description'>Subscribe our newsletter</p>
							<div className='newsletter'>
								<input type='email' placeholder='Email' />
								<span>
									<i class='ri-send-plane-line'></i>
								</span>
							</div>
						</div>
					</Col>

					<Col lg='12'>
						<div className='footer__bottom'>
							<p className='section__description d-flex align-items-center justify-content-center gap-1 pt-4'>
								<i class='ri-copyright-line'></i>Drive Cars Service, All rights reserved.
							</p>
						</div>
					</Col>
				</Row>
			</Container>
		</footer>
	);
};

export default Footer;
